<template>
    <v-container fluid>
        <v-card class="pa-2 ma-4">
            <v-row>
                <v-col>
                    <span class="headline mb-1">Order Search</span>
                </v-col>
                <v-col>
                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="dates"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="mx-8"
                                          v-model="computedDateFormatted"
                                          label="Select date range"
                                          prepend-icon="mdi-calendar-range"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="dates" no-title scrollable range>
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(dates); refreshItems();">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
        </v-card>
        
        <v-data-table class="elevation-1 pa-2 ma-4"
                      :items="items"
                      :headers="headers"
                      :loading="loading"
                      :server-items-length="totalItems"
                      :options.sync="options"
                      :footer-props="footerProps"
                      dense>
            <template v-slot:[`item.xId`]="{ item }">
              <a @click="goToOrder(item.id)">{{ item.orderCode || "" }}</a>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <a @click="goToOrder(item.id)">{{item.orderSubType || ""}} <span v-if="item.description"> - {{ item.description }}</span></a>
            </template>
            <template v-slot:[`item.scheduleId`]="{ item }">
              {{ item.schedule.name }}
            </template>
            <template v-slot:[`item.schedule.startDate`]="{ item }">
                {{ new Date(item.schedule.startDate).toLocaleDateString('pt-br') }}
            </template>
            <template v-slot:[`item.isActive`]="{ item }">
                <v-icon
                    v-if="item.isActive"
                    color="green"
                    class="my-2"
                >
                    mdi-checkbox-marked-circle
                </v-icon>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <v-checkbox class="ma-0" :disabled="item.isComplete || !canSelect(item.orderStateDetails)" :value="getActiveOrder===item.id" @click="switchActiveOrder(item.id)"></v-checkbox>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import appsettings from '../../appsettings.js';
    import axios from "axios";


    var today = new Date();
    var endDate = new Date(today.setMonth(today.getMonth() + 24));
    today = new Date();
    var startDate = new Date(today.setMonth(today.getMonth() - 24));
    export default {
        data: () => ({
            items: [],
            totalItems: 0,
            headers: [
                { text: "Schedule", value: "scheduleId", groupable: false, sortable: false },
                { text: "Type", value: "description", groupable: false, sortable: false },
                { text: "Order#", value: "xId", align: "start", groupable: false, sortable: false },
                { text: "Start", value: "schedule.startDate", groupable: false, sortable: false },
                { text: "Active", value: "isActive", groupable: false, sortable: false },
                { text: "Selected", value: "id", groupable: false, sortable: false },
                { text: "Status", value: "orderState", groupable: false, sortable: false }
            ],
            footerProps: {
                'items-per-page-options': appsettings.config.pages
            },
            open: [],
            options: {},
            loading: false,
            search: null,
            dates: [
                startDate.toISOString().split('T')[0],
                endDate.toISOString().split('T')[0],
            ],
            datesFormatted: [],
            isMounting: false,
            menu: false
        }),
        async mounted() {

            this.isMounting = true;

            this.options.itemsPerPage = this.getVrsUser.pageSize ?? appsettings.default.pageSize;

            this.isMounting = false;
  
            let data = await this.getRequisitionOrders();
            this.items = data.items;
            this.totalItems = data.total;
            this.loading=false;
        },
        computed: {
            ...mapGetters(['getVrsUser','getActiveOrder', 'getEnvironment', 'hasAccess']),
            computedDateFormatted() {
                return this.dates.map(this.formatDate).join(' ~ ');
            }
        },
        watch: {
            dates() {
                this.datesFormatted = this.dates.map(this.formatDate);
            },
            options: {
                handler() {
                    if (this.isMounting) { return; }
                    this.getRequisitionOrders()
                        .then(data => {
                            this.items = data.items;
                            this.totalItems = data.total;
                        });
                },
                deep: true,
            },
        },
        methods: {
            ...mapActions(["switchActiveOrder"]),
            async selectOrder(orderId) {
              
            },
            async getRequisitionOrders() {
               
              this.loading = true;
              const { sortBy, sortDesc, page, itemsPerPage } = this.options;
              
              let response = await axios.get(`/api/RequisitionOrder?locationId=${ this.$route.params.locationId }&start=${this.dates[0]}&end=${this.dates[1]}&PageNumber=${page}&PageSize=${itemsPerPage}`);
              var pageMetadata = JSON.parse(response.headers["x-pagination"]);
              this.loading = false;
              return {items:response.data, total: pageMetadata.TotalCount}
						
            },
            refreshItems() {
              this.getRequisitionOrders()
                .then(data => {
                  this.items = data.items;
                  this.totalItems = data.total;
                });
            },
            formatDate(date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');

                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;

                const [day, month, year] = date.split('/');

                return `${year}-${month}-${day}`;
            },
            goToOrder(orderId) {
                this.$router.push({ name: 'requisitionorder', params: { locationId: this.getVrsUser.locationId, locationDepartmentId: this.getVrsUser.locationDepartmentId, id: orderId }});
            },
            canSelect(orderState) {
                return ((orderState.isOpen && (this.hasAccess('MATERIALRO'))) || (orderState.isProcessing && (this.hasAccess('PROCESSRO'))))
            }
        }
    }
</script>